<template>
    <section>
        <slot name="modalBtn">
		    <button
                @click="openModal"
                class="uppercase shadow-md rounded-md py-2 px-2 md:py-4 md:px-4 3xl:text-lg hover:shadow-lg focus:outline-none"
                :class="btnClasses"
                type="button">
                Book a FREE 30-min phone consultation
            </button>
	    </slot>
        <div
            v-show="showModal"
            :id="modalId"
            class="main-modal fixed w-full h-full inset-0 z-50 overflow-auto flex justify-center items-center animated fadeIn faster"
            style="background: rgba(0,0,0,.7);">
            <div
                class="modal-container bg-white w-11/12 md:max-w-md mx-auto rounded shadow-lg z-50 overflow-y-auto">
                <div class="modal-content py-4 text-left">
                    <!--Title-->
                    <div class="flex justify-between items-center pb-3 border-b-2">
                        <p class="text-2xl font-bold text-green-500 px-4">Book Now</p>
                        <div class="modal-close cursor-pointer z-50 px-2 mr-2 rounded-md hover:bg-gray-50 py-2" @click="modalClose">
                            <svg class="fill-current text-black" xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                                viewBox="0 0 18 18">
                                <path
                                    d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z">
                                </path>
                            </svg>
                        </div>
                    </div>
                    <!--Body-->
                    <div class="my-5">
                        <div class="px-2 md:px-4">
                            <p class="text-sm" v-if="!showFormSuccess">
                                Please fill out the form below and I will contact you to Schedule your free consultation as soon as possible.
                            </p>

                            <div class="py-4 bg-green-100 px-4 rounded-md text-green-900 mt-4" v-if="showFormSuccess">
                                <p class="py-2">
                                    Thanks for submitting your info! <br> I will text you to confirm your appointment ASAP.
                                </p>
                            </div>
                            <form @submit.prevent="onSubmit" @reset="onReset" class="py-6" v-if="!showFormSuccess">
                                <input type="text" hidden name="source" value="Winnie's Landing Page">
                                <!-- <div class="py-4">
                                    <select
                                        name="service"
                                        v-model="bookingForm.service"
                                        required
                                        class="rounded-md text-sm w-full focus:outline-none"
                                    >
                                        <option value="-- Choose a Service --">-- Choose a Service --</option>
                                        <option v-for="option in services" :value="option.name" :key="option.id">
                                            {{option.name}}
                                        </option>
                                        
                                    </select>
                                    <span v-if="showServiceErr" class="text-red-500 text-sm">
                                        Please select a service.
                                    </span>
                                </div> -->
                                
                                <!-- First Name -->
                                <div class="py-2">
                                    <input
                                        class="border-1 border-gray-300 w-full rounded-md text-sm py-2 px-2 focus:outline-none"
                                        name="first_name"
                                        placeholder="First Name"
                                        v-model="bookingForm.first_name"
                                        required
                                    >
                                </div>

                                <!-- Last Name -->
                                <div class="py-2">
                                    <input
                                        name="last_name"
                                        class="border-1 border-gray-300 w-full rounded-md text-sm py-2 px-2 focus:outline-none"
                                        placeholder="Last Name"
                                        v-model="bookingForm.last_name"
                                        required
                                    >
                                </div>

                                <!-- Email -->
                                <div class="py-2">
                                    <input
                                        class="border-1 border-gray-300 w-full rounded-md text-sm py-2 px-2 focus:outline-none"
                                        name="email"
                                        placeholder="Email"
                                        v-model="bookingForm.email"
                                        type="email"
                                        required
                                    >
                                </div>

                                <!-- Phone -->
                                <div class="py-2">
                                    <input
                                        class="border-1 border-gray-300 w-full rounded-md text-sm py-2 px-2 focus:outline-none"
                                        v-model="bookingForm.phone"
                                        type="tel"
                                        name="phone"
                                        placeholder="Phone Number"        
                                        required
                                    >
                                </div>

                                <div class="py-2">
                                    <textarea
                                        class="border-1 border-gray-300 w-full rounded-md text-sm py-2 px-2 focus:outline-none"
                                        name="details"
                                        rows="5"
                                        placeholder="Details (optional)"
                                        v-model="bookingForm.details"
                                    ></textarea>
                                </div>

                                <button 
                                    type="submit" 
                                    class="rounded-md shadow px-2 py-2 mt-4 bg-green-400 w-32 focus:outline-none hover:bg-green-500 hover:shadow-md">
                                    Submit
                                </button>
                            </form>
                        </div>
                    </div>
                    <noscript>
                        <img height="1" width="1" 
                        :src="leadCaptured ? '"https://www.facebook.com/tr?id=2835940246654231&ev=Lead&noscript=1' : ''"/>
                    </noscript>
                    <!--Footer-->
                    <!-- <div class="flex justify-end pt-2">
                        <button
                            @click="modalClose"
                            class="focus:outline-none modal-close px-4 bg-gray-400 p-3 rounded-lg text-black hover:bg-gray-300">
                            Cancel
                        </button>
                        <button
                            @click="submit"
                            class="focus:outline-none px-4 bg-teal-500 p-3 ml-3 rounded-lg text-white hover:bg-teal-400">
                            Confirm
                        </button>
                    </div> -->
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import emailjs from 'emailjs-com';
export default {
    name: 'TuModal',
    props: {
        modalId: {
            type: String,
            required: true
        },
        btnClasses: {
            type: String,
            required: false
        }
    },
    data(){
        return {
            showModal: false,
            services: [{
                    id: 1,
                    name: "Direct and Holistic Therapy"
                },
                {
                    id: 2,
                    name: "Life Coaching"
                }
            ],

            selectedService: null,

            serviceOptions: [
                '-- Choose a Service --',
                'Direct and Holistic Therapy',
                'Life Coaching'
            ],

            bookingForm: {
                first_name: '',
                last_name: '',
                service: '-- Choose a Service --',
                email: '',
                phone: '',
                details: ''
            },

            showFormSuccess: false,

            showServiceErr: false,
            leadCaptured: false
        }
    },

    computed: {
        modal(){
            return document.getElementById(this.modalId)
        },
        disableSubmitBtn(){

        }
    },

    watch: {

    },

    created(){
        this.initModalClose()
    },

    methods: {
        modalClose(){
			this.modal.classList.remove('fadeIn');
            this.modal.classList.add('fadeOut');
			setTimeout(() => {
                this.showModal = false
			}, 500);
        },
        
        openModal(){
            this.showModal = true
			this.modal.classList.remove('fadeOut');
            this.modal.classList.add('fadeIn');
        },
        
        initModalClose(){
            window.addEventListener('click', (event)=> {
                if (event.target == this.modal) this.modalClose()
            })
        },

        async onSubmit(e){
            // if (this.bookingForm.service === this.serviceOptions[0]){
            //     this.showServiceErr = true
            // } else {
            //     this.showServiceErr = false
            // }

            if (
                // this.bookingForm.service !== this.serviceOptions[0]
                //&&
                this.bookingForm.first_name !== ''
                &&
                this.bookingForm.last_name !== ''
                &&
                this.bookingForm.email !== ''
                &&
                this.bookingForm.phone !== ''
            ){
                await this.sendEmail(e)
            }
                
        },

        onReset(){

        },

        sendEmail(e){
            emailjs.sendForm(
                    process.env.VUE_APP_EMAILJS_SERVICE_ID, 
                    process.env.VUE_APP_EMAILJS_BOOKING_TEMPLATE_ID, 
                    e.target, 
                    process.env.VUE_APP_EMAILJS_USER_ID
                )
                .then((result) => {
                    window.fbq.push('track', 'Lead')
                    this.leadCaptured = true
                    // this.bookingForm.service = this.serviceOptions[0]
                    this.bookingForm.first_name = ''
                    this.bookingForm.last_name = ''
                    this.bookingForm.email = ''
                    this.bookingForm.phone = ''
                    this.bookingForm.details = ''
                    this.showFormSuccess = true
                }, (error) => {
                    console.error('FAILED...', error);
                });
    
        }
    }
}
</script>

<style scoped>
    @import url('https://fonts.googleapis.com/css2?family=Open+Sans&family=Playfair+Display:wght@400;700&display=swap');
    .animated {
        -webkit-animation-duration: 1s;
        animation-duration: 1s;
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both;
    }

    .animated.faster {
        -webkit-animation-duration: 500ms;
        animation-duration: 500ms;
    }

    .fadeIn {
        -webkit-animation-name: fadeIn;
        animation-name: fadeIn;
    }

    .fadeOut {
        -webkit-animation-name: fadeOut;
        animation-name: fadeOut;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
        }

        to {
            opacity: 1;
        }
    }

    @keyframes fadeOut {
        from {
            opacity: 1;
        }

        to {
            opacity: 0;
        }
    }

    button{
        font-family: 'Open Sans', sans-serif;
    }
</style>